import { injectReducer } from '@modules/reducers'
import { injectSagas } from '@modules/sagas'

// Sync route definition
export default (store: Store): RouteConfig => ({
  path: '/sentiment-category',
  layout: true,
  getComponent: async () => {
    const CategoriesLayout = await import(
      /* webpackChunkName: "categories-modules" */ './components/CategoriesLayout'
    )
    const { reducer, rootSagas, } = await import(
      /* webpackChunkName: "categories-modules" */ './CategoriesModule'
    )

    injectReducer(store, { key: 'sentiment-category', reducer, })
    injectSagas(store, rootSagas)

    return {
      children: CategoriesLayout.default,
    }
  },
  childRoutes: [
    {
      path: '/',
      title: 'categories.list_title',
      getComponent: async () => {
        const CategoriesListView = await import(
          /* webpackChunkName: "categories-modules" */ './components/CategoriesListView'
        )
        return {
          children: CategoriesListView.default,
        }
      },
    },

    {
      title: 'categories.new_title',
      path: '/new',
      getComponent: async () => {
        const CategoriesFormView = await import(
          /* webpackChunkName: "categories-modules" */ './components/CategoriesFormView'
        )
  
        return {
          children: CategoriesFormView.default,
        }
      },
    },

    {
      title: 'categories.new_title',
      path: '/edit/:id',
      getComponent: async () => {
        const CategoriesFormView = await import(
          /* webpackChunkName: "categories-modules" */ './components/CategoriesFormView'
        )
  
        return {
          children: CategoriesFormView.default,
        }
      },
    },
  ],
})
